// extracted by mini-css-extract-plugin
export default {"card":"pay-redirect_card__sczw4","links":"pay-redirect_links__TDUKb","uno":"pay-redirect_uno__at-ul"};